import { Button, Dropdown, Grid, type MenuProps } from "antd";
import { AppstoreOutlined, CheckOutlined, DownOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router";
import { useEdel } from "../../contexts/color-mode";
import { WORKSPACES, WORKSPACE_MAP, workspaceFromPath } from "../../constants";
import { gradientCss } from "../../theme";

/**
 * Çalışma alanı değiştirici — Header'da her zaman görünür.
 * CRM / Planlama / Dosya Paylaşımı arası geçiş + başlangıç ekranı (/hub).
 * Google Workspace waffle deseni.
 */
export const AppSwitcher = () => {
  const { palette: p } = useEdel();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const screens = Grid.useBreakpoint();
  const isMobile = screens.md === false;
  const current = workspaceFromPath(pathname);

  const items: MenuProps["items"] = [
    ...WORKSPACES.map((w) => ({
      key: w.key,
      onClick: () => navigate(w.path),
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            minWidth: 248,
            padding: "4px 0",
          }}
        >
          <span
            style={{
              width: 34,
              height: 34,
              flex: "0 0 auto",
              borderRadius: 9,
              background: gradientCss(w.gradient),
              boxShadow: p.shadowSm,
            }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 600, color: p.text, lineHeight: 1.3 }}>
              {w.label}
            </div>
            <div
              style={{
                fontSize: 12,
                color: p.textSoft,
                whiteSpace: "normal",
                lineHeight: 1.35,
              }}
            >
              {w.description}
            </div>
          </div>
          {current === w.key && (
            <CheckOutlined style={{ color: p.primary, fontSize: 13 }} />
          )}
        </div>
      ),
    })),
    { type: "divider" as const },
    {
      key: "hub",
      icon: <AppstoreOutlined />,
      label: "Başlangıç ekranı",
      onClick: () => navigate("/hub"),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={["click"]} placement="bottomLeft">
      <Button
        type="text"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          height: 40,
          paddingInline: 10,
          fontWeight: 600,
        }}
      >
        <AppstoreOutlined style={{ fontSize: 17, color: p.primary }} />
        {!isMobile && (
          <>
            <span>{WORKSPACE_MAP[current]?.label ?? "Uygulamalar"}</span>
            <DownOutlined style={{ fontSize: 10, color: p.textSoft }} />
          </>
        )}
      </Button>
    </Dropdown>
  );
};
